import { Stack } from "@quorumus/plum"
import styled from "styled-components"

export const SkeletonStack = styled(Stack)`
    gap: 32px;
    width: 100%;
`
